import {
  REPLACE_POPUP,
  PUSH_POPUP,
  CLOSE_ALL_POPUPS,
  CLOSE_ACTIVE_POPUP,
  CLOSE_TARGET_POPUP,
  REPLACE_ACTIVE_POPUP,
} from './constants';

export const closePopups = () => ({ type: CLOSE_ALL_POPUPS });

export const closeTargetPopup = (popupIndex) => ({
  type: CLOSE_TARGET_POPUP, payload: popupIndex,
});

export const closeActivePopup = () => ({ type: CLOSE_ACTIVE_POPUP });
// close all popups and open a new one
export const openPopup = (payload) => ({ type: REPLACE_POPUP, payload });
// close the top popup and open a new one
export const replaceActivePopup = (payload) => ({ type: REPLACE_ACTIVE_POPUP, payload });
export const pushPopup = (payload) => ({ type: PUSH_POPUP, payload });
